@if (tasks() !== null) {
  <div
    class="text-navy-700 flex flex-wrap items-start justify-evenly gap-1 text-center"
  >
    @for (step of steps(); track step.title; let first = $first) {
      @let bgColor =
        step.status
          ? step.status === 'COMPLETED'
            ? 'bg-green-500'
            : 'bg-blue-700'
          : 'bg-gray-200';
      @if (!first) {
        @let dotsClassName =
          `mt-7 h-2 w-2 items-center justify-center rounded-full ${bgColor}`;
        <div [ngClass]="dotsClassName"></div>
        <div [ngClass]="dotsClassName"></div>
      }

      <div class="flex flex-col items-center text-[13px]">
        <div
          class="mx-2 my-1 flex h-14 w-14 items-center justify-center rounded-full bg-gray-200"
          [ngClass]="bgColor"
        >
          <div class="custom-icon {{ step.icon }} !h-full !w-full !m-3"></div>
        </div>
        <div
          class="mx-auto max-w-[60px] text-center text-[13px] opacity-[0.9]"
          [ngClass]="{
            'opacity-100':
              step.status === 'ACTIVE' || step.status === 'COMPLETED',
          }"
        >
          {{ step.title }}
        </div>
      </div>
    }
  </div>
}
